
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUser } from '../hooks/useUser';

import { Box, Paper, Stack, Typography, Avatar, List, ListItem, ListItemAvatar, ListItemText, Button, Skeleton, alpha, Pagination } from '@mui/material';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import theme from '../../../core/components/layout/theme';
import moment from 'moment';
import CustomTypography from '../../../core/components/ui/CustomTypography';
import CustomChipComponent from '../../../core/components/common/custom-chip.component';
import UserProfileListComponent from '../components/user-profile.list.component';
import { useProfile } from '../hooks/useProfile';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomButton from '../../../core/components/ui/CustomButton';


function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name), width: 80, height: 80
    },
    children: `${name?.split(' ')[0][0]}`,
  };
}

export default function UserProfileViewPage() {
   
    const profile_uid = new URLSearchParams(window.location.search).get("profile_uid");
    const user_uid = new URLSearchParams(window.location.search).get("user_uid");
    
    const navigate = useNavigate();

    const {viewUserProfile, profileDetails, loadingDetails, getUserProfile, profileList, loading} = useProfile();
    
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const rowsPerPage = 10;

    const handleChangePagination = (event, page) => { 
        setCurrentPage(page); 
    }

    useEffect(() => {
        if (profileList) {
            setTotalPages(profileList?.totalPages);
        }
    }, [profileList])


    useEffect(() => {
        if (currentPage) {
            const parameters = {
                page: currentPage ,
                limit: rowsPerPage,
                userUID: user_uid
            };

            getUserProfile(parameters);
        }
    }, [currentPage, user_uid])

    useEffect(() => {
        if (user_uid) {
            let paramters = {
                page: 1,
                limit: rowsPerPage,
                userUID: user_uid
            };
            getUserProfile(paramters);
        }
    }, [user_uid]);

    useEffect(() => {
        if (profile_uid) {
            let paramters = {
                profileUID: profile_uid,
                userUID: user_uid
            };
            viewUserProfile(paramters);
        }
    }, [profile_uid]);

    return (
        <>
         <CustomButton
            variant="text" 
            startIcon={<ArrowBackIcon fontSize="small" />}
            label="Back"
            customStyles={{fontSize: 14, mt: 2}}
            onClick={() => navigate(-1)}
        />
        <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, mt: 3}}>
                <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                >
                    <Stack
                    direction="row"
                    spacing={2}
                    flex={1}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                    >
                        {
                            loadingDetails ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar {...stringAvatar(profileDetails?.profile_type)} />
                                    </ListItemAvatar>
                                    <ListItemText sx={{pl: 2, width: '100%'}} primary={<Typography variant="h5">{profileDetails?.profile_type}</Typography>} secondary={<Typography variant="subtitle2">{profileDetails?.role}</Typography>} />
                                </ListItem>
                            </List>
                        }
                    </Stack>

                    <Stack
                    direction="column"
                    spacing={2}
                    flex={1}
                    sx={{
                        justifyContent: "center",
                        alignItems: "end",
                        pr: 4
                    }}
                    >
                        <CustomChipComponent category="profileStatusStyles"
                            label={(profileDetails?.status === "Active") ? "Active" 
                                : 
                                    (profileDetails?.status === "Deactivated") ? "Deactivated"
                                :
                                    (profileDetails?.status === "Pending") ? "Pending"
                                :
                                    profileDetails?.status
                            }
                        />
                    </Stack>
                </Stack>
            </Paper>

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, p: 3, mt: 1}}>
                <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="h3"
                            text={"Profile Information"}
                            customStyles={{
                                marginBottom: 0, 
                                fontSize: 20,
                                fontWeight: 700
                            }}
                        />
                    </Box>
                    {/* <Stack
                    direction="column"
                    flex={1}
                    sx={{
                        justifyContent: "center",
                        alignItems: "end",
                    }}
                    >
                        <Button 
                            variant="outlined" 
                            startIcon={<BorderColorIcon />}
                            sx={{textTransform: 'capitalize'}}
                            onClick={() => navigate('/user/update?user_uid=' + profileDetails?.user_uid)}
                        >
                            Edit
                        </Button>
                    </Stack> */}
                </Stack>

                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}
                    >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"ID Type"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(loadingDetails) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={profileDetails?.id_type}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"ID Number"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(loadingDetails) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={profileDetails?.id_no}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                </Stack>

                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}
                    >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Created"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(loadingDetails) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={moment(profileDetails?.created_at).format("MMMM DD, YYYY")}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box flex={1}/>

                    <Box sx={{display: "inline-grid"}} flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Updated"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(loadingDetails) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={moment(profileDetails?.updated_at).format("MMMM DD, YYYY")}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>
                    <Box flex={1} />
                </Stack>
            </Paper>
           <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, p: 3, mt: 1}}>
                <CustomTypography 
                    variant="h3"
                    text={"Other Profile"}
                    customStyles={{
                        marginBottom: 0, 
                        fontSize: 20,
                        fontWeight: 700
                    }}
                />
                <UserProfileListComponent profileList={profileList} loading={loading} user_uid={user_uid}/>

                <Pagination
                    count={ totalPages}
                    page={currentPage}
                    onChange={handleChangePagination}
                    sx={{
                        margin: "auto",
                        width: "fit-content",
                        paddingTop: 3,
                        "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: "#0b99da",
                            color: "#fff",
                        }
                    }}
                />
            </Paper>
        </>
    );
}